// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-indent{border-left:1px solid var(--gray);margin-left:22px;padding-left:34px}", ""]);
// Exports
module.exports = exports;
